import { Link } from 'react-router-dom';

import { LegalTermWrapper } from 'components/index';

import style from 'src/components/layout/LegalTermWrapper/LegalTermWrapper.module.scss';

const AnalysisRegulationsPL = () => {
  return (
    <LegalTermWrapper
      pageTitle={'Regulamin promocji'}
      documentTitle={'Regulamin promocji: „Zgłoś Gabinet na analizę procesu zakupowego i odbierz voucher do wybranego sklepu”'}
    >
      <h2 className={style.column_header}>
        <span>§ 1 </span>
        <span>Postanowienia ogólne</span>
      </h2>
      <ol className={style.list}>
        <li>
          Organizatorem promocji jest CBM 16 sp. z o.o., z siedzibą w 954E, 36-002 Jasionka, Polska, NIP: 5170402504 (dalej:
          „Organizator”).
        </li>
        <li>Promocja trwa od 6.06.2025 r do 30.06.2025 r</li>
        <li>
          Celem promocji jest zachęcenie gabinetów stomatologicznych do udziału w analizie procesu zakupowego materiałów
          stomatologicznych.
        </li>
      </ol>
      <h2 className={style.column_header}>
        <span>§ 2 </span>
        <span>Zasady udziału w promocji</span>
      </h2>
      <ol className={style.list}>
        <li>
          Uczestnikiem promocji może być osoba fizyczna prowadząca działalność gospodarczą lub przedstawiciel osoby prawnej,
          reprezentujący gabinet stomatologiczny zarejestrowany na terenie Polski.
        </li>
        <li>
          Aby wziąć udział w promocji, należy:
          <ul className={style.second_list}>
            <li>
              Wypełnić formularz zgłoszeniowy dostępny na stronie <Link to={'/analysis'}>https://avalio.io/analysis</Link>,
            </li>
            <li>
              Podać następujące dane:
              <ul className={style.unordered_list}>
                <li>Nazwa gabinetu</li>
                <li>NIP gabinetu</li>
                <li>Numer telefonu kontaktowego</li>
                <li>Adres e-mail</li>
                <li>Szacunkowe miesięczne wydatki gabinetu na materiały stomatologiczne</li>
                <li>Preferowany rodzaj vouchera (Allegro, Empik, Decathlon, Sephora)</li>
                <li>Adres e-mail, na który ma zostać przesłany voucher</li>
              </ul>
            </li>
            <li>Załączyć faktury zakupowe z minimum ostatniego miesiąca (w formacie PDF lub skanów).</li>
          </ul>
        </li>
      </ol>
      <h2 className={style.column_header}>
        <span>§ 3 </span>
        <span>Warunki przyznania vouchera</span>
      </h2>
      <ol className={style.list}>
        <li>Warunkiem otrzymania vouchera jest przesłanie dokumentów umożliwiających rzetelną analizę procesu zakupowego.</li>
        <li>
          Zespół Organizatora dokonuje weryfikacji zgłoszenia oraz oceny, czy przesłane faktury są kompletne i nadają się do
          analizy. Decyzja Zespołu jest ostateczna.
        </li>
        <li>
          W przypadku pozytywnej weryfikacji, voucher o wartości 200 zł zostanie przesłany na wskazany adres e-mail w ciągu 14 dni
          roboczych.
        </li>
      </ol>
      <h2 className={style.column_header}>
        <span>§ 4 </span>
        <span>Ochrona danych osobowych</span>
      </h2>
      <ol className={style.list}>
        <li>
          Administratorem danych osobowych Uczestników jest CBM 16 sp. z o.o., z siedzibą w 954E, 36-002 Jasionka, Polska, NIP:
          5170402504
        </li>
        <li>
          Dane osobowe będą przetwarzane wyłącznie w celu przeprowadzenia promocji, zgodnie z art. 6 ust. 1 lit. b i f RODO.
        </li>
        <li>
          Uczestnik ma prawo dostępu do swoich danych, ich poprawiania, usunięcia lub ograniczenia przetwarzania, a także
          wniesienia skargi do organu nadzorczego.
        </li>
        <li>
          Szczegółowe informacje na temat przetwarzania danych osobowych dostępne są w Polityce Prywatności na stronie:{' '}
          <Link to={'/privacy-policy'}>https://avalio.io/privacy-policy</Link>.
        </li>
      </ol>
      <h2 className={style.column_header}>
        <span>§ 5 </span>
        <span>Postanowienia końcowe</span>
      </h2>
      <ol className={style.list}>
        <li>
          Organizator zastrzega sobie prawo do zakończenia promocji przed czasem lub zmiany jej warunków, o czym poinformuje na
          stronie internetowej.
        </li>
        <li>
          Promocja nie jest grą losową, konkursem ani loterią promocyjną w rozumieniu ustawy z dnia 19 listopada 2009 r. o grach
          hazardowych.
        </li>
        <li>Przesłanie zgłoszenia jest równoznaczne z akceptacją niniejszego Regulaminu.</li>
      </ol>
    </LegalTermWrapper>
  );
};

export default AnalysisRegulationsPL;
